import React, { createContext, useContext, useState } from 'react'
import { ChannelTeamItem } from '../types/types'

interface OnboardingUserData {
  firstName: string
  lastName: string
  phone: string
  gender: string
  birthYear: string
}

interface State {
  userData: {
    value: Partial<OnboardingUserData>
    set: (data: Partial<OnboardingUserData>) => void
  }
  company: {
    value: string | undefined
    set: (company: string) => void
  }
  followedTeams: {
    value: ChannelTeamItem[]
    set: (team: ChannelTeamItem[]) => void
  }
  registerState: {
    isLoading: boolean
    setIsLoading: (value: boolean) => void
  }
}

const initialState: State = {
  userData: {
    value: {},
    set: () => {}
  },
  company: {
    value: 'solidsport',
    set: () => {}
  },
  followedTeams: {
    value: [] as ChannelTeamItem[],
    set: () => {}
  },
  registerState: {
    isLoading: false,
    setIsLoading: () => {}
  }
}

const OnBoardingContext = createContext(initialState)

export const OnBoardingProvider = ({
  companyName,
  children
}: {
  companyName?: string
  children: React.ReactNode
}) => {
  const [company, setCompany] = useState(
    companyName || initialState.company.value
  )
  const [followedTeams, setFollowedTeams] = useState(
    initialState.followedTeams.value
  )
  const [userData, setUserData] = useState<Partial<OnboardingUserData>>({})

  const [resisterIsLoading, setRegisterIsLoading] = useState(false)

  const contextValue = {
    userData: {
      value: userData,
      set: (data: Partial<OnboardingUserData>) =>
        setUserData((prev) => ({ ...prev, ...data }))
    },
    company: {
      value: company,
      set: setCompany
    },
    followedTeams: {
      value: followedTeams,
      set: setFollowedTeams
    },
    registerState: {
      isLoading: resisterIsLoading,
      setIsLoading: setRegisterIsLoading
    }
  }

  return (
    <OnBoardingContext.Provider value={contextValue}>
      {children}
    </OnBoardingContext.Provider>
  )
}

export const useCompanyName = () => {
  const context = useContext(OnBoardingContext)
  if (!context) {
    throw new Error('useCompanyName must be used within a CompanyProvider')
  }
  return context.company
}

export const useFollowedTeams = () => {
  const context = useContext(OnBoardingContext)
  if (!context) {
    throw new Error('useFollowedTeams must be used within a CompanyProvider')
  }
  return context.followedTeams
}

export const useUserData = () => {
  const context = useContext(OnBoardingContext)
  if (!context) {
    throw new Error('useUserData must be used within a CompanyProvider')
  }
  return context.userData
}

export const useOnBoardingRegisterState = () => {
  const context = useContext(OnBoardingContext)
  if (!context) {
    throw new Error(
      'useOnBoardingRegisterState must be used within a CompanyProvider'
    )
  }
  return context.registerState
}
